/* eslint-disable */
export default
[
  {
    "data": [
      {
        "definition": "A common provision of a mortgage that allows the holder to demand the entire outstanding mortgage balance due and payable in the event of a breach of the mortgage contract.",
        "key": "1",
        "term": "Acceleration Clause"
      },
      {
        "definition": "A mortgage that allows the lender to adjust the interest rate in accordance with a specified index periodically and as agreed to at the inception of the loan. Also called a “variable-rate mortgage.”",
        "key": "2",
        "term": "Adjustable-Rate Mortgage (ARM)"
      },
      {
        "definition": "The period of time that dictates the interest rate adjustments on an adjustable rate mortgage. For example, a six month ARM would have an adjustment every six months.",
        "key": "3",
        "term": "Adjustment Period"
      },
      {
        "definition": "The right by which someone occupying a piece of land acquires title against the real owner, if the occupant's possession has been actual, continuous, hostile, visible, and distinct for a statutory period.",
        "key": "4",
        "term": "Adverse Possession"
      },
      {
        "definition": "Desirable or useful features that enhance the value of a building or place. Examples are: off-street reserved parking within a condominium community, tennis courts, a swimming pool, or the proximity of public transportation.",
        "key": "5",
        "term": "Amenity"
      },
      {
        "definition": "A national association of title insurance companies, abstractors, and attorneys specializing in real property laws. The association represents the title insurance and abstracting industry and establishes standard procedures and title policy forms. ALTA's website is www.alta.org.",
        "key": "6",
        "term": "American Land Title Association (ALTA)"
      },
      {
        "definition": "Repayment of mortgage debt with equal periodic payments of both principal and interest, calculated to retire the obligation at the end of a fixed period.",
        "key": "7",
        "term": "Amortization"
      },
      {
        "definition": "A table showing the amounts of principal and interest due at regular intervals and the mortgage balance after each payment is made.",
        "key": "8",
        "term": "Amortization Schedule"
      },
      {
        "definition": "The net amount of credit extended for the consumer's use. The amount financed is not necessarily equivalent to the note amount, proceeds, or principal amount of the loan; it is generally equivalent to the total of payments less the finance charge.",
        "key": "9",
        "term": "Amount Financed"
      },
      {
        "definition": "The effective interest rate (the interest rate plus points paid at closing) for a loan repaid over its full term. The APR expresses on an annualized basis the charges imposed on the borrower to obtain a loan, including interest, discount points, and other costs. It represents the dollar amount of finance charges paid either up front or over the life of the loan, converted to an annual interest rate.",
        "key": "10",
        "term": "Annual Percentage Rate (APR)"
      },
      {
        "definition": "Income derived from products sold to mortgage loan customers, such as bank credit card fees, insurance premium commissions, and other charges.",
        "key": "11",
        "term": "Ancillary Fees"
      },
      {
        "definition": "A report made by a professional appraiser to establish the current market value of the property securing the prospective mortgage.  The appraisal takes into consideration location, zoning, and size, as well as the sale price of similar properties in the same neighborhood. Federal agencies and GSEs require the use of a state-licensed or certified appraiser.",
        "key": "12",
        "term": "Appraisal"
      },
      {
        "definition": "The transfer of ownership, rights, or interest in a property, as in a mortgage, lease, or deed of trust. Mortgages and other security instruments are regularly assigned from one investor to another and commitments by HUD/FHA to insure mortgages may be assigned by one originating lender to another before insurance.",
        "key": "13",
        "term": "Assignment"
      },
      {
        "definition": "A special condition that allows title to transfer when the loan is not paid in full. In this case, the servicer works with the seller, the buyers, and/or their agents to satisfy the stipulations of the debt instruments and the underwriting requirements of the end investor. Assumptions may be advantageous if the terms of the mortgage are better than the prevailing rate and they are not changed by the lender when the mortgage is assumed.",
        "key": "14",
        "term": "Assumption"
      },
      {
        "definition": "A buyer's acceptance of primary liability for payment of an existing note secured by a mortgage or deed of trust. In the agreement, the buyer agrees to pay the obligation originally incurred by the seller. Typically, the seller remains secondarily liable unless specifically released by the lender.",
        "key": "15",
        "term": "Assumption of Mortgage"
      }
    ],
    "title": "A"
  },
  {
    "data": [
      {
        "definition": "A mortgage with equal monthly payments of principal and interest and a large final payment due at a specified date, usually in five or seven years. Payments of principal and interest are not sufficient to amortize (or pay off) the loan by the maturity date. This financing tool is usually offered to applicants who expect to sell or refinance the property within a specified period of time.",
        "key": "16",
        "term": "Balloon Mortgage/Balloon Loan"
      },
      {
        "definition": "A scheduled payment on a mortgage that is larger than other periodic payments, usually the unamortized final payment.",
        "key": "17",
        "term": "Balloon Payment"
      },
      {
        "definition": "A person (or persons) who receives benefits from a life insurance policy, will, contract, or deed of trust.",
        "key": "18",
        "term": "Beneficiary"
      },
      {
        "definition": "Mortgage with payments due every two weeks, totally 26 payments a year.",
        "key": "19",
        "term": "Bi-Weekly Mortgage"
      },
      {
        "definition": "The evidence of a loan. It is a debt security under which the issuer owes the holders a debt and, depending on the terms of the bond, is obliged to pay them interest (the coupon) and/or to repay the principal at a later date, termed the maturity date.",
        "key": "20",
        "term": "Bond"
      },
      {
        "definition": "A person or organization that takes out a loan from a bank under an agreement to pay it back later, typically with interest",
        "key": "21",
        "term": "Borrower"
      },
      {
        "definition": "Failure to perform under a contract or the violation of a legal obligation.",
        "key": "22",
        "term": "Breach"
      },
      {
        "definition": "A mortgage with a below-market interest rate that results in lower monthly payments for the first few years or the entire term of the mortgage. A buydown is made by a lender in return for money received from a builder, seller, or buyer.",
        "key": "23",
        "term": "Buydown Mortgage"
      }
    ],
    "title": "B"
  },
  {
    "data": [
      {
        "definition": "A document issued by the Department of Veterans Affairs that verifies a veteran's eligibility for a VA mortgage guaranty. To be eligible for a VA loan, the applicant must be a qualifying veteran, the unmarried widow of a veteran, a Public Health Service Officer, or an active-duty serviceman (with 181 days of service).",
        "key": "24",
        "term": "Certificate of Eligibility (COE)"
      },
      {
        "definition": "A chain of title shows the history of property ownership from the original source of title to present ownership. Usually the chain begins with the original grant or sale of land from the government to a private citizen.",
        "key": "25",
        "term": "Chain of Title"
      },
      {
        "definition": "In real estate, the delivery of a deed, the signing of a note, and the disbursement of funds necessary to consummate a sale or loan transaction.",
        "key": "26",
        "term": "Closing"
      },
      {
        "definition": "Second or additional person equally responsible for payments on a mortgage; a co-borrower does not have to take title to the property, but usually has to sign the mortgage note",
        "key": "27",
        "term": "Co-Borrower"
      },
      {
        "definition": "A second borrower who signs a mortgage loan with a mortgagor. The co-mortgagor's income, assets, and debts are combined with the mortgagor's for underwriting and ratio analysis purposes. For FHA loans, the co-mortgagor's name must appear on the FHA Certificate of Commitment and the mortgage or deed of trust. For full guaranty under the VA's program, the co-mortgagor must be either a spouse or another eligible veteran. The co-mortgagor assumes equal responsibility for the debt and a share in ownership of the property.",
        "key": "28",
        "term": "Co-Mortgagor"
      },
      {
        "definition": "One who agrees to assume the debt obligation if the principal borrower should default on mortgage payments. A co-signer assumes only personal liability and has no ownership interest in the property; his or her income and obligations are used in the underwriting process to reinforce the credit of the principal borrower.",
        "key": "29",
        "term": "Co-Signer"
      },
      {
        "definition": "Property pledged as security for a debt, for example, mortgaged real estate.",
        "key": "30",
        "term": "Collateral"
      },
      {
        "definition": "Collateral documents include the note, security instrument, title policy, and mortgage insurance policy/certificate.",
        "key": "31",
        "term": "Collateral Documents"
      },
      {
        "definition": "Property defined as office buildings, shopping centers, apartment buildings and other property which is utilized for the production of income rather than as residences. If residential real estate has more than four units it is considered commercial real estate.",
        "key": "32",
        "term": "Commercial Real Estate"
      },
      {
        "definition": "An agreement, often in writing, between a lender and a borrower to loan money at a future date, subject to specified conditions. In secondary marketing, an agreement in writing, between a lender and an investor to buy and sell mortgages under specific terms.",
        "key": "33",
        "term": "Commitment"
      },
      {
        "definition": "Conventional mortgage with loan amounts and underwriting guidelines that are in conformity to those used by the Government Sponsored Enterprise (Fannie Mae and Freddie Mac). Most conventional mortgages are conforming loans.",
        "key": "34",
        "term": "Conforming Loan"
      },
      {
        "definition": "Clause in a contract that requires the completion of a certain act or the occurrence of a certain event.",
        "key": "35",
        "term": "Contingency"
      },
      {
        "definition": "Mortgage financing which is not insured or guaranteed by a government agency.",
        "key": "36",
        "term": "Conventional Financing"
      },
      {
        "definition": "A report issued by an independent agency that helps a lender verify information concerning an applicant's credit standing. A standard credit report contains: legal information for the past seven years; the terms, balances, and ratings for all debts on the credit application, and adverse credit over 30 days; debts that are not disclosed on the credit application; all recent inquiries; and any matters of record in the local recorder's office that may adversely affect a mortgage loan (judgments, garnishments, liens, pending lawsuits, prison terms, etc.).",
        "key": "37",
        "term": "Credit Report"
      },
      {
        "definition": "A consumer with a continuing relationship with a financial institution.",
        "key": "38",
        "term": "Customer"
      }
    ],
    "title": "C"
  },
  {
    "data": [
      {
        "definition": "Total monthly debts (i.e., prospective housing expense plus other consumer debts such as car loans, student loans, and credit cards) divided by the applicant's gross monthly income. An acceptable ratio generally should not exceed 36% for conforming loans and 41% for government loans. These requirements vary among private investors and others.",
        "key": "39",
        "term": "Debt-to-Income Ratio"
      },
      {
        "definition": "The document by which title to real property is transferred or conveyed from one party to another.",
        "key": "40",
        "term": "Deed"
      },
      {
        "definition": "Allows an eligible borrower who has successfully completed the deed-in-lieu and who is qualified to pay a fair market rent to lease back their home for a period of one year or until they can make alternative living arrangements.",
        "key": "41",
        "term": "Deed-for-Lease"
      },
      {
        "definition": "A loss mitigation technique that allows the borrower to deed the property back to the lender for full forgiveness of the debt. This option is not used unless all other options have been exhausted.",
        "key": "42",
        "term": "Deed-in-Lieu of Foreclosure"
      },
      {
        "definition": "A security instrument in which the borrower conveys title to real property to a trustee for the benefit of the lender to secure repayment of the note. The trustee reconveys the title upon the payment of the debt, or conversely, sells the land and pays the debt in the event of a default by the borrower.",
        "key": "43",
        "term": "Deed of Trust"
      },
      {
        "definition": "Non-payment of a mortgage or other loan in accordance with the terms as specified in the note.",
        "key": "44",
        "term": "Default"
      },
      {
        "definition": "The process of packaging and delivering the loan documents to the investor or its agent under the terms of the commitment.",
        "key": "45",
        "term": "Delivery"
      },
      {
        "definition": "A governmental entity responsible for the implementation and administration of housing and urban development programs. HUD was established by the Housing and Urban Development Act of 1965 to supersede the Housing and Home Finance Agency.",
        "key": "46",
        "term": "Department of Housing and Urban Development (HUD)"
      },
      {
        "definition": "A cabinet-level agency of the federal government. The Servicemen's Readjustment Act of 1944 authorized the agency to administer a variety of benefit programs designed to facilitate the adjustment of returning veterans to civilian life. Among the benefit programs is the VA Home Loan Guaranty program, which encourages mortgage lenders to offer long-term, low down payment financing to eligible veterans by partially guaranteeing lender against loss upon foreclosure.",
        "key": "47",
        "term": "Department of Veteran's Affairs (VA)"
      },
      {
        "definition": "Decrease in value due to age, wear and tear, and other factors.",
        "key": "48",
        "term": "Depreciation"
      },
      {
        "definition": "A form used to inform the borrower of certain costs or conditions of obtaining a loan. Mortgage lending disclosures required by law at or within three days of application include the Good Faith Estimate and the initial Truth in Lending Statement, among others.",
        "key": "49",
        "term": "Disclosure"
      },
      {
        "definition": "Dual tracking occurs when a servicer simultaneously evaluates a borrower for loan modifications or other alternatives to foreclosure based on receipt of a complete loss mitigation application at the same time that it takes certain steps to foreclose on the property, such as recording a notice of default. The new rules specifically prohibit a servicer from making the first notice or filing required by applicable law for any foreclosure process until the loan is more than 120 days delinquent.",
        "key": "50",
        "term": "Dual Tracking"
      },
      {
        "definition": "A clause in a mortgage stating that if the mortgagor sells, transfers, or in any way encumbers the property, then the mortgagee has the right to implement an acceleration clause making the balance of the obligation due.",
        "key": "51",
        "term": "Due-on-Sale Clause"
      }
    ],
    "title": "D"
  },
  {
    "data": [
      {
        "definition": "The concept that, for a company, as production of goods increases in amount, the cost to produce each unit decreases in cost. For mortgage bankers, there are clear economies of scale opportunities for loan portfolios up to the 50,000 - 100,000 range. Numerous studies indicate that the incremental opportunities of scale flatten out beyond this range. Hence, there has been a tendency over the years for loan servicing to become more and more concentrated in larger servicing operations.",
        "key": "52",
        "term": "Economies of Scale"
      },
      {
        "definition": "The interest rate plus the points paid at closing. The effective interest rate represents the true cost of the loan to the borrower. The effective interest rate depends on how long the borrower keeps the loan. For example, consider a $100,000 loan at 8% interest rate with three points paid at closing. The effective interest rate for a 30-year term is 8.32%. If this loan were repaid in 6 years, the effective interest rate would be 8.66%.",
        "key": "53",
        "term": "Effective Interest Rate"
      },
      {
        "definition": "Net ownership interest in a property in excess of claims or liens against it. In the case of real estate, the difference between fair market value and current indebtedness.",
        "key": "54",
        "term": "Equity"
      },
      {
        "definition": "Money collected from a borrower by a lender that is held in a trust account and used to pay taxes, insurance, and other fees when due. Also, to collect and hold funds in an escrow account. (In some parts of the country, escrows of taxes and insurance premiums are called impounds or reserves.)",
        "key": "55",
        "term": "Escrow"
      },
      {
        "definition": "A trust account in which the lender holds funds collected from a borrower and uses the money to pay taxes and insurance premiums when they become due. An initial escrow account is generally established at settlement. In some parts of the country, escrows of taxes and insurance premiums are called impounds or reserves. Escrow accounts are generally required by most lenders.",
        "key": "56",
        "term": "Escrow Account"
      },
      {
        "definition": "A type of settlement that occurs in some parts of the country in which the documents and loan funds are delivered to a third party, called the escrow agent. The process does not reflect the traditional settlement with buyer and seller present; the closing is finalized by a third party acting to execute the closing documents.",
        "key": "57",
        "term": "Escrow Closing"
      },
      {
        "definition": "Interest in real property. Estates are classified into two categories: freehold and leasehold.",
        "key": "58",
        "term": "Estate"
      }
    ],
    "title": "E"
  },
  {
    "data": [
      {
        "definition": "The nation's largest mortgage investor and one of the two major government-sponsored enterprises. Fannie Mae is a stockholder corporation that supports the secondary market in mortgages on residential property with mortgage purchases and securitization programs. Created in 1968 by an amendment to Title III of the National Housing Act.",
        "key": "59",
        "term": "Fannie Mae"
      },
      {
        "definition": "A federal agency that, among other things, directs the activities of the Federal Insurance Administration and establishes flood insurance rates and terms of coverage, issues policies, processes claims, and identifies and maps flood-prone areas.",
        "key": "60",
        "term": "Federal Emergency Management Agency (FEMA)"
      },
      {
        "definition": "A federal agency within the Department of Housing and Urban Development (HUD) that provides mortgage insurance for residential mortgages and sets standards for construction and underwriting. The FHA does not lend money, nor does it plan or construct housing.",
        "key": "61",
        "term": "Federal Housing Administration (FHA)"
      },
      {
        "definition": "Established in 2008 to provide effective supervision, regulation and housing mission oversight of Fannie Mae, Freddie Mac and the Federal Home Loan Banks in order to promote their safety and soundness, support housing finance and affordable housing, and support a stable and liquid mortgage market.",
        "key": "62",
        "term": "Federal Housing Finance Agency"
      },
      {
        "definition": "Loans made by any entity that regularly extends credit and is repaid in more than four installments. Most loans are federally regulated. An exception might be a home seller holding a private note for the borrower.",
        "key": "63",
        "term": "Federally Regulated Loans"
      },
      {
        "definition": "Greatest possible interest a person can have in real estate, including the right to dispose of the property or pass it on to one's heirs.",
        "key": "64",
        "term": "Fee Simple"
      },
      {
        "definition": "A mortgage loan made through an approved lender and insured by the Federal Housing Administration within the Department of Housing and Urban Development. Maximum loan amounts on FHA loans are dictated by the county in which the property is located.",
        "key": "65",
        "term": "FHA Loan"
      },
      {
        "definition": "A type of insurance that generally covers losses caused by dishonest or fraudulent acts by employees and others.",
        "key": "66",
        "term": "Fidelity (Bond)"
      },
      {
        "definition": "The cost of credit expressed as a dollar amount, including any charge payable directly or indirectly by the applicant and imposed directly or indirectly by the lender as a condition to receive credit. The finance charge includes interest for the loan and other loan costs, such as discount points, origination fees, and private mortgage insurance.",
        "key": "67",
        "term": "Finance Charge"
      },
      {
        "definition": "Evaluation of the existing and potential income stream of the real estate to determine prospective cash flow and debt service capacity.",
        "key": "68",
        "term": "Financial Statement Analysis"
      },
      {
        "definition": "A mortgage in which the principal and interest rate portions of the mortgage payment remain the same for the life of the loan.",
        "key": "69",
        "term": "Fixed-Rate Mortgage (FRM)"
      },
      {
        "definition": "Insurance that reimburses the policyholder for damage to property caused by flood. Only properties in a designated flood area typically have flood insurance.",
        "key": "70",
        "term": "Flood Insurance"
      },
      {
        "definition": "Refraining from taking legal action despite the fact that the mortgage is in arrears. Usually granted only when a borrower makes satisfactory arrangements to pay the amount owed at a future date.",
        "key": "71",
        "term": "Forbearance"
      },
      {
        "definition": "Hazard coverage obtained by a lender to protect its security interest in a property in which the borrower has failed to renew existing coverage. Premiums for this coverage are usually above market rates and most mortgage instruments allow for this premium to be charged to the borrower.",
        "key": "72",
        "term": "Force-Placed Coverage"
      },
      {
        "definition": "Foreclosure is the legal process of taking a property from a borrower who is not complying with the terms of the note. The property is sold to pay the outstanding debt in case the borrower defaults.",
        "key": "73",
        "term": "Foreclosure"
      },
      {
        "definition": "Organizations that handle the entire post-foreclosure claims process for a fee, and warranty completeness and accuracy of the amounts due to the mortgage banker under their claims.",
        "key": "74",
        "term": "Foreclosure Claims Specialists"
      },
      {
        "definition": "One of the two major government-sponsored enterprises. This stockholder-owned corporation, a portion of whose board of directors is appointed by the President of the United States, supports the secondary market in mortgages on residential property with mortgage purchases and securitization programs. Created by Congress in Title III of the Emergency Home Finance Act of 1970.",
        "key": "75",
        "term": "Freddie Mac"
      }
    ],
    "title": "F"
  },
  {
    "data": [
      {
        "definition": "Grantor promises, represents, and warrants that he or she has good title to the property being conveyed; that there are not laws or encumbrances outstanding against the title not on record; and he or she will defend the title in the event of a title dispute (some states use a grant deed instead of a warranty deed).",
        "key": "76",
        "term": "General Warranty Deed"
      },
      {
        "definition": "A federal government corporation that is a constituent part of the Department of Housing and Urban Development. Among other functions, it guarantees securities backed by mortgages that are insured or guaranteed by other government agencies. Created in 1968 by an amendment to Title III of the National Housing Act.",
        "key": "77",
        "term": "Ginnie Mae"
      },
      {
        "definition": "A document that informs borrowers of the approximate costs they will pay at or before settlement, based on common practice in the locality. Under requirements of the Real Estate Settlement Procedures Act (RESPA), the mortgage banker or mortgage broker, if any, must deliver or mail the GFE to the applicant within three business days after the application is received.",
        "key": "78",
        "term": "Good Faith Estimate (GFE)"
      },
      {
        "definition": "Mortgage insured or guaranteed by the government (FHA, VA, RHS, or State Bond Agencies).",
        "key": "79",
        "term": "Government Mortgage"
      },
      {
        "definition": "A private organization with government charters and backing, which facilitates the secondary market by providing a network for the purchase, sale, and guarantee of existing mortgages and mortgage pools. Examples are Fannie Mae and Freddie Mac.",
        "key": "80",
        "term": "Government-Sponsored Enterprise (GSE)"
      },
      {
        "definition": "A period of time (usually 15 days) after a mortgage payment is due in which the lender will not charge a late penalty or report the payment as late. Example: A payment is due on the first of the month. If the payment has not been received by the first of the month it is considered late. However, depending on their grace days, no late fees will be charged until after those grace days have passed.",
        "key": "81",
        "term": "Grace Period"
      },
      {
        "definition": "A mortgage with payments that increase based on a set schedule over a period of years and then level off. The early year payments are lower than the amount set by the interest rate. This financing tool is designed for the applicant who expects a higher income in the near future.",
        "key": "82",
        "term": "Graduated Payment Mortgage (GPM)"
      },
      {
        "definition": "A person receiving interest in property.",
        "key": "83",
        "term": "Grantee"
      },
      {
        "definition": "The person(s) conveying an interest in real property. In the case of a deed, this would be the seller of the property.",
        "key": "84",
        "term": "Grantor"
      },
      {
        "definition": "A graduated payment mortgage in which increases in a borrower's mortgage payments are used to accelerate reduction of principal on the mortgage. Due to increased payments, the borrower acquires equity more rapidly and retires the debt earlier.",
        "key": "85",
        "term": "Growing Equity Mortgage (GEM)"
      },
      {
        "definition": "A promise by one party to pay a debt or perform an obligation contracted for or by another in the event the obligor fails to pay or perform as contracted. For VA loans, the amount of money VA will reimburse a lender upon default of a VA mortgage. Also referred to as the amount of entitlement or eligibility.",
        "key": "86",
        "term": "Guaranty"
      }
    ],
    "title": "G"
  },
  {
    "data": [
      {
        "definition": "A type of casualty insurance that provides compensation to the insured for damage to or destruction of property.",
        "key": "87",
        "term": "Hazard Insurance"
      },
      {
        "definition": "An open-end loan, usually recorded as a second mortgage, that permits borrowers to obtain cash advances based on an approved line of credit.",
        "key": "88",
        "term": "Home Equity Line of Credit (HELOC)"
      },
      {
        "definition": "A fee typically paid monthly by a homeowner to a homeowners association for the association to maintain and/or repair common areas owned by all homeowners within a planned unit development. Homeowners association fees are not escrowed by lenders, but are typically computed in qualification ratios.",
        "key": "89",
        "term": "Homeowners Association (HOA) Fees"
      },
      {
        "definition": "Insurance coverage that provides compensation to the insured for damage to or destruction of property improvements caused by fire or other hazards. In addition, homeowners insurance protects against loss or damage to personal property (what is inside the home), liability for injuries to occupants and guests, vandalism, and additional living expenses in case the insured premises become untenable. Although lenders generally only require a hazard insurance policy, many buyers opt for a full homeowners policy if they opt to live in the house.",
        "key": "90",
        "term": "Homeowners' Insurance"
      },
      {
        "definition": "Total monthly housing expense (PITI and other applicable expenses) divided by the applicant's gross monthly income (income before any deductions). Acceptable ratio should generally not exceed 28% for conforming loans and 29% for government loans. Private investors and state government agencies may have other percentage requirements. Also called the front-end ratio.",
        "key": "91",
        "term": "Housing-to-Income Ratio"
      },
      {
        "definition": "Settlement summary form required by RESPA to be used by closing agents.",
        "key": "92",
        "term": "HUD-1 Settlement Statement"
      }
    ],
    "title": "H"
  },
  {
    "data": [
      {
        "definition": "Consideration in the form of money paid for the use of money, usually expressed as an annual percentage. Also, a right, share, or title in property.",
        "key": "93",
        "term": "Interest"
      },
      {
        "definition": "A loss mitigation technique that assists the borrower who has a high interest rate loan resulting in an unaffordable payment amount, and the borrower who is unable to refinance at a lower rate due to market conditions, property value, or past payment record.",
        "key": "94",
        "term": "Interest Rate Reduction"
      }
    ],
    "title": "I"
  },
  {
    "data": [
      {
        "definition": "A form of co-ownership giving each tenant equal interest and equal rights in the property, including the right of survivorship.",
        "key": "95",
        "term": "Joint Tenancy"
      },
      {
        "definition": "Nonconforming loans that have principal balances exceeding the maximum mortgage limits of Fannie Mae or Freddie Mac, the two largest investors. Jumbo loans typically have higher interest rates and down payment requirements than conforming loans.",
        "key": "96",
        "term": "Jumbo Loans"
      }
    ],
    "title": "J"
  },
  {
    "data": [
      {
        "definition": "A loan made for the purpose of purchasing land only, not improvements on or to the land; also called an acquisition loan.",
        "key": "97",
        "term": "Land Acquisition Loan"
      },
      {
        "definition": "Fees that are assessed to an account if a payment is not received by the expiration of one's grace period days.",
        "key": "98",
        "term": "Late Charge"
      },
      {
        "definition": "A lender is an individual, a public or private group, or a financial institution that makes funds available to another with the expectation that the funds will be repaid. Repayment will include the payment of any interest or fees. Repayment may occur in increments (as in monthly mortgage payment) or as a lump sum.",
        "key": "99",
        "term": "Lender"
      },
      {
        "definition": "When the mortgagee merely has a lien on the property and title remains with the mortgagor.",
        "key": "100",
        "term": "Lien Theory"
      },
      {
        "definition": "A legal hold or claim of a creditor on the property of another as security for debt. Liens may be against real or personal property. A mortgage is one form of a lien.",
        "key": "101",
        "term": "Lien"
      },
      {
        "definition": "A form of flood insurance placed on first mortgage loans by the company who performed the original flood determination. The determining company advises the servicer of any changes to flood maps which would then trigger the need for flood insurance or advise if flood insurance can be cancelled.",
        "key": "102",
        "term": "Life of Loan Coverage"
      },
      {
        "definition": "The ability to readily convert assets or investments to cash.",
        "key": "103",
        "term": "Liquidity"
      },
      {
        "definition": "A loss mitigation technique that allows the borrower to add the delinquency to the end of the mortgage in the form of an extension of the term or a balloon payment at a specified time in the future, a reduction of the rate, or a combination of all. Allows the borrower to become current on payments.",
        "key": "104",
        "term": "Loan Modification"
      },
      {
        "definition": "The ratio of the amount of the loan to lesser of the appraised value or sales price of real property (expressed as a percentage). For example, a property with a sales price of $100,000, an appraised value of $105,000, and a loan of $80,000 would have an 80% LTV (80,000/100,000=80%).",
        "key": "105",
        "term": "Loan-to-Value (LTV) Ratio"
      },
      {
        "definition": "A postal address, maintained by the firm's bank, which is used solely for the purpose of collecting checks. A major goal of a lockbox is to reduce collection float, since the receipts are immediately credited to the firm's bank account.",
        "key": "106",
        "term": "Lockbox"
      },
      {
        "definition": "Mortgage reserves maintained by mortgage insurers sufficient to cover catastrophic losses.",
        "key": "107",
        "term": "Loss Coverage"
      },
      {
        "definition": "Insurance payments in settlement of a claim for damage to mortgaged property. Drafts are generally made out to both the mortgagee and mortgagor.",
        "key": "108",
        "term": "Loss Draft"
      },
      {
        "definition": "The reduction or elimination of credit losses to lenders, servicers, investors and insurers. In the broadest view this can include any activity associated with recovery of the debt. Therefore everything from collections to sale of real estate owned (REO) can be considered loss mitigation. It includes both retention options (such as refinance, loan modification, and forbearance) and disposition options (such as short sales and deeds-in-lieu).",
        "key": "109",
        "term": "Loss Mitigation"
      }
    ],
    "title": "L"
  },
  {
    "data": [
      {
        "definition": "An agreement between buyer and seller for the purchase and sale of a specified mortgage product in which both parties are obligated to perform.",
        "key": "110",
        "term": "Mandatory Commitment"
      },
      {
        "definition": "The date on which an agreement expires; the termination of a mortgage note.",
        "key": "111",
        "term": "Maturity Date"
      },
      {
        "definition": "Monthly payment of principal and interest collected by mortgage lenders; may also include escrowed items for taxes or insurance.",
        "key": "112",
        "term": "Monthly Payment"
      },
      {
        "definition": "A security instrument in which the borrower pledges a property as security for a debt. By extension, the document evidencing the pledge.",
        "key": "113",
        "term": "Mortgage"
      },
      {
        "definition": "An investment instrument backed by a group of mortgage loans as a security. The group of loans is called a pool. Ownership is evidenced by an undivided interest in the pool of mortgages or trust deeds. Income from the underlying mortgages is used to pay interest and principal on the securities.",
        "key": "114",
        "term": "Mortgage-Backed Security"
      },
      {
        "definition": "An individual, firm, or corporation that originates, sells, and/or services loans secured by mortgages on real property.",
        "key": "115",
        "term": "Mortgage Banker"
      },
      {
        "definition": "A firm or individual who, for a commission, matches borrowers and lenders. A mortgage broker takes applications and sometimes processes loans, but generally does not use its own funds for closing.",
        "key": "116",
        "term": "Mortgage Broker"
      },
      {
        "definition": "Insurance that protects lenders against loss in the event of default by the borrower. This allows lenders to make loans with lower down payments. FHA loans are insured by the federal government; FHA charges borrowers a mortgage insurance premium (MIP).  Conventional loans are insured by private entities that offer private mortgage insurance. Loans with LTV ratios above 80% generally require mortgage insurance.",
        "key": "117",
        "term": "Mortgage Insurance (MI)"
      },
      {
        "definition": "On FHA loans, the amount paid by a borrower to FHA for mortgage insurance protection for the lender.",
        "key": "118",
        "term": "Mortgage Insurance Premium"
      },
      {
        "definition": "Evidences the existence of the loan. It's a written promise stating the borrower's promise to repay the loan including interest rates and shows the borrower's responsibility to pay back the loan.",
        "key": "119",
        "term": "Mortgage Note"
      },
      {
        "definition": "Lender of money that is secured by real estate.",
        "key": "120",
        "term": "Mortgagee"
      },
      {
        "definition": "A clause that may be attached to an insurance policy stipulating that the lender will receive a portion of insurance proceeds sufficient to satisfy the unpaid amount of a loan in the event of a loss.",
        "key": "121",
        "term": "Mortgagee Clause"
      },
      {
        "definition": "Borrower of money that is secured by real estate.",
        "key": "122",
        "term": "Mortgagor"
      }
    ],
    "title": "M"
  },
  {
    "data": [
      {
        "definition": "Unpaid interest that is added to the mortgage principal in a loan in which the principal balance increases rather than decreases because the mortgage payments do not cover the full amount of the interest due.",
        "key": "123",
        "term": "Negative Amortization"
      },
      {
        "definition": "Conventional mortgage that does not meet Fannie Mae or Freddie Mac standards. These loans may have a loan amount, loan-to-value ratio, term, or some other aspect that exceeds permissible limits specified in Fannie Mae/Freddie Mac regulations. An example is a jumbo loan.",
        "key": "124",
        "term": "Nonconforming Loan"
      },
      {
        "definition": "General term for any kind of paper or document signed by a borrower that is an acknowledgment of the debt, and is by inference a promise to pay.",
        "key": "125",
        "term": "Note"
      }
    ],
    "title": "N"
  },
  {
    "data": [
      {
        "definition": "The securing of an application from a prospective borrower. Also sometimes used to refer to the entire loan production process — from the taking of the loan application through the closing.",
        "key": "126",
        "term": "Origination"
      }
    ],
    "title": "O"
  },
  {
    "data": [
      {
        "definition": "Collections technique in which borrowers make partial payments for a specified period of time. May assist the borrower who has temporarily lost a job or suffered a temporary reduction in income due to illness. After the agreed-upon specified period of time during which partial payments are made, all delinquent payments must be recovered.",
        "key": "127",
        "term": "Partial Payments"
      },
      {
        "definition": "A financing arrangement in which a mortgage lender receives a portion of cash flow, gross revenue, or shares of ownership of a real estate venture as part of the loan.",
        "key": "128",
        "term": "Participation"
      },
      {
        "definition": "Partial interests in a loan, rather than ownership of the entire loan.",
        "key": "129",
        "term": "Participation Interests"
      },
      {
        "definition": "The amount a borrower owes to bring the loan current and up to date. Quite often with a mortgage, the monthly payment amount consists of principal, interest, taxes, and insurance.",
        "key": "130",
        "term": "Payment Amount"
      },
      {
        "definition": "A statement detailing the unpaid principal balance, accrued interest, outstanding late charges, legal fees, and all other amounts necessary to pay off the lender in full.",
        "key": "131",
        "term": "Payoff Letter"
      },
      {
        "definition": "A Latin phrase meaning “per day.” On mortgages, the interest due is calculated on a per diem basis so it's the amount of interest due for one day. Payoff statements will state if the loan isn't paid in full on the date specified, the per diem amount of interest is due for each additional day of the delay is $xx.xx.",
        "key": "132",
        "term": "Per Diem"
      },
      {
        "definition": "Acronym for the items included in a monthly mortgage payment: principal, interest, taxes, and insurance.",
        "key": "133",
        "term": "PITI"
      },
      {
        "definition": "A comprehensive development plan for a large land area. A PUD usually includes residences, roads, schools, recreational facilities, commercial, office, and industrial areas. Also, a subdivision having lots or areas owned in common and reserved for the use of some or all of the owners of the separately owned lots.",
        "key": "134",
        "term": "Planned Unit Development (PUD)"
      },
      {
        "definition": "Amount equal to 1% of the principal amount of a mortgage. Loan discount points are a one-time charge assessed at closing by the lender to increase the yield on the mortgage loan to a competitive position with other types of investments.",
        "key": "135",
        "term": "Point"
      },
      {
        "definition": "The collection of loans held by a mortgage lender for servicing or investment.",
        "key": "136",
        "term": "Portfolio"
      },
      {
        "definition": "A lender who holds loans in their portfolio and does not sell to investors in the secondary market.  The lender usually holds the loan's until maturity or until the loan is paid off.",
        "key": "137",
        "term": "Portfolio Lender"
      },
      {
        "definition": "A legal document authorizing one person to act on behalf of another.",
        "key": "138",
        "term": "Power of Attorney"
      },
      {
        "definition": "Settlement of a mortgage default where the borrower allows the mortgage insurance company or servicer to sell the property securing the mortgage rather than foreclose on it.",
        "key": "139",
        "term": "Pre-Foreclosure Sale"
      },
      {
        "definition": "Payment of all or part of a mortgage debt before it is due.",
        "key": "140",
        "term": "Prepayment"
      },
      {
        "definition": "Charge the mortgagor pays the mortgagee for the privilege of prepaying the loan.",
        "key": "141",
        "term": "Prepayment Penalty/Prepayment Premium"
      },
      {
        "definition": "The right to require the noteholder to demand payment of amounts due.",
        "key": "142",
        "term": "Presentment"
      },
      {
        "definition": "The original balance of money lent, excluding interest. Also, the remaining balance of a loan, excluding interest.",
        "key": "143",
        "term": "Principal"
      },
      {
        "definition": "Principal curtailment is when the borrower makes extra principal payments in an effort to reduce the outstanding principal balance. This can also be called a partial curtailment.",
        "key": "144",
        "term": "Principal Curtailment"
      },
      {
        "definition": "On privately insured loans, the insuring company may choose to accept the property and pay the total amount outstanding, or reject the property and pay the insurance benefit only, depending on which option will be least costly.",
        "key": "145",
        "term": "Privately Insured Foreclosures"
      },
      {
        "definition": "Insurance written by a private company protecting the lender against financial loss from a borrower who defaults on a mortgage. Private mortgage insurance is generally required on conventional loans that have a greater than 80% loan-to-value ratio.",
        "key": "146",
        "term": "Private Mortgage Insurance (PMI)"
      },
      {
        "definition": "Private companies writing mortgage insurance that protects the mortgage lender against financial loss when a borrower defaults on a mortgage.",
        "key": "147",
        "term": "Private Mortgage Insurers"
      },
      {
        "definition": "In the past, lenders would frequently drop the requirement for mortgage insurance once the current loan-to-value ratio dropped to 80% or less, which could be based on a new appraisal. This was done at the borrower's request. The general rule has evolved into more stringent requirements for deleting the insurance, primarily driven by Fannie Mae and Freddie Mac policies.",
        "key": "148",
        "term": "Private Mortgage Insurance Cancellation"
      },
      {
        "definition": "Completion of a mortgage loan application and collection of supporting documents for underwriting.",
        "key": "149",
        "term": "Processing"
      },
      {
        "definition": "The official recorded document that obligates the borrower as well as non-occupant co-signers to repay the loan in accordance with the lender's terms.",
        "key": "150",
        "term": "Promissory Note"
      },
      {
        "definition": "Insurance that provides compensation against property loss or damage. Also called hazard insurance.",
        "key": "151",
        "term": "Property Insurance"
      },
      {
        "definition": "Refers to a creditor's practice of imposing a late fee when a consumer sends a timely payment in an amount sufficient to cover the regularly scheduled payment but insufficient to cover a prior unpaid late or delinquency fee. If the creditor allocates payments first to late fees, the consumer's payment only partially covers the currently scheduled payment, resulting in a new late fee. If the consumer continues to pay only the scheduled payment, late fees will continually be assessed (hence, the phrase pyramiding of late fees).",
        "key": "152",
        "term": "Pyramiding Late Fees"
      }
    ],
    "title": "P"
  },
  {
    "data": [
      {
        "definition": "A deed relinquishing all interest, title, or claim that an owner has in a property. A quitclaim deed implies no warranty.",
        "key": "153",
        "term": "Quitclaim Deed"
      }
    ],
    "title": "Q"
  },
  {
    "data": [
      {
        "definition": "A written agreement between buyer and seller stating terms and conditions of a sale or exchange of property. This contract discloses to the lender the location of the property, the purchase price, contingencies, and special considerations that may affect the condition of the property. The signing of the sales contract takes the house off the market. Typically, buyers shop for a mortgage after a sales contract is signed.",
        "key": "154",
        "term": "Real Estate Sales Contract"
      },
      {
        "definition": "Federal law that regulates the settlement practices within the real estate industry. This law requires the provision of Good Faith Estimates of Closing Costs, prohibits kickbacks for referrals of related services, and standardizes the closing with a required form and format (HUD-1).",
        "key": "155",
        "term": "Real Estate Settlement Procedures Act (RESPA)"
      },
      {
        "definition": "The payoff of an existing loan with a new loan using the same property as security. There are many reasons for refinancing; however, the most common reasons are to raise capital or to replace a mortgage with a new mortgage that provides a better rate of interest and possibly better terms.",
        "key": "156",
        "term": "Refinancing"
      },
      {
        "definition": "Compliance to local, state, and federal laws.",
        "key": "157",
        "term": "Regulatory Compliance"
      },
      {
        "definition": "When a borrower can make one lump sum payment sufficient to repay the arrearage. For example, a borrower in the early stages of default could use a tax return to pay any arrerage. Alternatively, if a loan has a Private Mortgage Insurer (PMI), a partial claim would allow the borrower to reinstate the loan.",
        "key": "158",
        "term": "Reinstatement"
      },
      {
        "definition": "Can be used when a temporary hardship has been resolved and a borrower can resume making regular monthly payments in addition to a portion of the amount of the arrearage over a period agreed upon between the borrower and the servicer.",
        "key": "159",
        "term": "Repayment Plan"
      },
      {
        "definition": "Mortgage that uses present equity in the property to fund monthly payments from the lender to the borrower in lieu of the borrower receiving the proceeds of the loan in a lump sum.",
        "key": "160",
        "term": "Reverse Mortgage"
      },
      {
        "definition": "A government agency within the U.S. Department of Agriculture that offers various financing programs available to aid in the development of rural America. These rural housing programs are divided into three categories: Community Facilities (CF), Single Family Housing (SFH), and Multifamily Housing (MFH). These programs were formerly operated by the Rural Development Administration and the Farmers Home Administration.",
        "key": "161",
        "term": "Rural Housing Service (RHS)"
      },
      {
        "definition": "A mortgage loan made by an approved lender and guaranteed by the Rural Housing Service within the U.S. Department of Agriculture. RHS loans are primarily used to help low-income individuals or households purchase homes in rural areas. Funds can be used to build, repair, renovate, or relocate a home, or to purchase and prepare sites, including providing water and sewage facilities.",
        "key": "162",
        "term": "RHS loan"
      },
      {
        "definition": "The renewal of a loan at maturity. Also, reinvestment of proceeds of a sale of an investment into another, which defers payment of taxes on the gain from the sale.",
        "key": "163",
        "term": "Rollover"
      },
      {
        "definition": "The risk that existing loans could be paid off before their loan term is up. The possible reasons for early payoff include foreclosure, the sale of the home, or a refinance at a better rate. An example of refinancing would be a 7% 30-year fixed rate loan that refinances to 5% in its fifth year. Runoff results in a reduction of anticipated revenue for the owner/investor as well as a reduction in the value of the servicing portfolio.",
        "key": "164",
        "term": "Runoff Risk"
      }
    ],
    "title": "R"
  },
  {
    "data": [
      {
        "definition": "A mortgage that has rights subordinate to a first mortgage. Also called a second trust.",
        "key": "165",
        "term": "Second Mortgage"
      },
      {
        "definition": "The securitization and sale of closed mortgage loans to investors.",
        "key": "166",
        "term": "Secondary Marketing"
      },
      {
        "definition": "The market in which lenders and investors sell existing mortgages or mortgage-backed securities, thereby providing greater availability of funds for additional mortgage lending. The two largest investors on the secondary market are the government sponsored enterprises Fannie Mae and Freddie Mac.",
        "key": "167",
        "term": "Secondary Mortgage Market"
      },
      {
        "definition": "A bond where the borrower places a pledge on a particular asset. Should the borrower default, the asset becomes collateral as form of repayment.",
        "key": "168",
        "term": "Secured Bond"
      },
      {
        "definition": "The process of pooling loans into mortgage-backed securities for sale into the secondary mortgage market.",
        "key": "169",
        "term": "Securitization"
      },
      {
        "definition": "The official recorded documentation evidencing the pledge of real estate as collateral for the loan. In some states, the security instrument is the mortgage; in other states, the security instrument is a deed of trust.",
        "key": "170",
        "term": "Security Instrument"
      },
      {
        "definition": "A mortgage banking function that includes the receipt of payments, customer service, escrow administration, investor accounting, collections, and foreclosures. Also called loan administration.",
        "key": "171",
        "term": "Servicing"
      },
      {
        "definition": "A written agreement between an investor and mortgage servicer stipulating the rights and obligations of each party.",
        "key": "172",
        "term": "Servicing Agreement"
      },
      {
        "definition": "The fee earned by a servicer for administering a loan for an investor. The fee is deducted from the gross interest rate passed onto the investor with each monthly payment. For example, if the interest rate for a loan is 6% and the lender charges the investor 25 basis points (0.25%) for servicing the loan, the servicer keeps 1/4% of the interest collected and passes the other 5 3/4% onto the investor.",
        "key": "173",
        "term": "Servicing Fee"
      },
      {
        "definition": "During the warehousing period, the closed loan packages that will be delivered to an investor are put into a specific order (as determined by the investor), prepared for shipping, and delivered. Shipping includes matching loans with investor commitments, collecting all of the trailing post-closing documents, checking loan files for completeness, imaging or making copies of loan file documents, and preparing transmittal documents for delivery to the investor.",
        "key": "174",
        "term": "Shipping"
      },
      {
        "definition": "Allows the borrower to sell the property at an amount in accordance with the  current market value of the property. Investors, including Fannie Mae, Freddie Mac, and FHA, have published acceptable net proceeds which they will accept as a full payoff for the loan. This option is especially useful in cases where a property has lost value and when attempts at other retention options for the borrower have failed.",
        "key": "175",
        "term": "Short Sale"
      },
      {
        "definition": "A collections technique that allows a borrower to suspend payments temporarily or tender a reduced payment for a specified period of time. After this period, the borrower must plan to resume regular monthly payments plus a payment towards the delinquent payments. A forbearance is appropriate when the borrower experiences a temporary hardship.",
        "key": "176",
        "term": "Special Forbearance"
      },
      {
        "definition": "A deed containing a covenant whereby the grantor agrees to protect the grantee against any claims arising during the grantor's period of ownership.",
        "key": "177",
        "term": "Special Warranty Deed"
      },
      {
        "definition": "A legal agreement which establishes one debt as ranking behind another debt in the priority for collecting repayment from a debtor. The priority of debt is extremely important if the debtor defaults on payments or declares bankruptcy. If a borrower has a mortgage and ELOC, the mortgage is in 1st position and the ELOC is in 2nd position; the ELOC is subordinate.",
        "key": "178",
        "term": "Subordination"
      },
      {
        "definition": "Nonconforming loans made to borrowers that do not meet traditional conforming market requirements, usually because of credit, employment, income, or property issues. Because they represent higher risk, subprime loans have larger down payment requirements and higher interest rates than conforming loans.",
        "key": "179",
        "term": "Subprime Loans"
      },
      {
        "definition": "A measurement of land prepared by a registered land surveyor, showing the location of the land with reference to known points, its dimensions, and the location and dimensions of any improvements. The survey includes pertinent facts about a particular property and any easements or encroachments affecting it.",
        "key": "180",
        "term": "Survey"
      }
    ],
    "title": "S"
  },
  {
    "data": [
      {
        "definition": "The sale of property by a taxing authority or an officer of the court acting on a judgment to satisfy the payment of delinquent taxes.",
        "key": "181",
        "term": "Tax Sale"
      },
      {
        "definition": "Entity or individual that completely or partially takes the mortgage loan application from a borrower. A TPO may process, underwrite, or fund the  mortgage before transferring, assigning, or selling it to another mortgage lender. Brokers are one type of TPO.",
        "key": "182",
        "term": "Third-Party Originator (TPO)"
      },
      {
        "definition": "Written evidence of the right to or ownership in property. In the case of real estate, the documentary evidence of ownership is the title deed that specifies in whom the legal estate is vested, and the history of ownership and transfers. Title may be acquired through purchase, inheritance, devise, gift, or through foreclosure of a mortgage.",
        "key": "183",
        "term": "Title"
      },
      {
        "definition": "Written evidence of temporary title insurance coverage that runs for a limited time and must be replaced by a permanent policy.",
        "key": "184",
        "term": "Title Binder"
      },
      {
        "definition": "Insurance that protects against loss caused by defect of title to real estate.",
        "key": "185",
        "term": "Title Insurance"
      },
      {
        "definition": "Some kind of conditional title to the real estate is given to the mortgagee to secure the debt.",
        "key": "186",
        "term": "Title Theory"
      },
      {
        "definition": "An examination of public records, laws, and court decisions to ensure that no one except the seller has a valid claim to the property, and to disclose past and current facts regarding ownership of the subject property.",
        "key": "187",
        "term": "Title Search"
      },
      {
        "definition": "Documents that reconcile all of the principal, interest, and escrow funds that are changing hands or being “transmitted” between the lender and investor.",
        "key": "188",
        "term": "Transmittal Documents"
      },
      {
        "definition": "A form that summarizes the data contained within a loan application.",
        "key": "189",
        "term": "Transmittal Form"
      },
      {
        "definition": "A fiduciary relationship whereby legal title to a property is transferred to a trustee with the intention that such property be administered by the trustee for the benefit of another, the beneficiary, who holds equitable title to such property.",
        "key": "190",
        "term": "Trust"
      },
      {
        "definition": "The transfer of the legal title of real estate property to a third party until a borrower repays their debt (for example, a mortgage) to the lender.",
        "key": "191",
        "term": "Trust Deed"
      },
      {
        "definition": "A federal law that requires a truth in lending statement to be disclosed for consumer loans, including disclosure of the annual percentage rate, or APR, as well as the right of rescission period which follows the closings of refinances.",
        "key": "192",
        "term": "Truth In Lending Act"
      }
    ],
    "title": "T"
  },
  {
    "data": [
      {
        "definition": "In mortgage banking, the analysis of risk involved in making a mortgage loan to determine whether the risk is acceptable to the lender. Underwriting involves the evaluation of the property as outlined in the appraisal report, and of the borrower's ability and willingness to repay the loan.",
        "key": "193",
        "term": "Underwriting"
      },
      {
        "definition": "An appraisal form utilized by appraisers of residential properties to estimate the value of properties to be financed with FHA, VA, and conventional mortgages.",
        "key": "194",
        "term": "Uniform Residential Appraisal Report (URAR)"
      },
      {
        "definition": "A form that is accepted by all major mortgage sources for application of residential mortgages. This form is also known as Fannie Mae 1003/Freddie Mac 65/FHA 2900/VA 1802.",
        "key": "195",
        "term": "Uniform Residential Loan Application (URLA)"
      },
      {
        "definition": "A settlement summary form required by RESPA to be used by closing agents.",
        "key": "196",
        "term": "Uniform Settlement Statement (HUD-1)"
      },
      {
        "definition": "A bond that is supported in good faith of the borrower and their credit score.",
        "key": "197",
        "term": "Unsecured Bond"
      }
    ],
    "title": "U"
  },
  {
    "data": [
      {
        "definition": "A fee charged on VA mortgages to cover the administrative costs of the program.",
        "key": "198",
        "term": "VA Funding Fee"
      },
      {
        "definition": "A mortgage loan made by an approved lender and guaranteed by the Department of Veterans Affairs. VA loans are made to eligible veterans and those currently serving in the military, and can have a lower down payment than other types of loans.",
        "key": "199",
        "term": "VA Loan"
      },
      {
        "definition": "A form that requests and secures verifications of amounts on deposit at financial institutions. When a depository institution is also the applicant's creditor, the VOD verifies the obligation.",
        "key": "200",
        "term": "Verification of Deposit (VOD)"
      },
      {
        "definition": "A form that requests and secures documentation of a mortgage applicant's work history and/or occupation, to assist in the lender's credit investigation.",
        "key": "201",
        "term": "Verification of Employment (VOE)"
      },
      {
        "definition": "A form that requests and secures verification of payments paid on an applicant's current or past mortgage.",
        "key": "202",
        "term": "Verification of Mortgage (VOM)"
      },
      {
        "definition": "A form that requests and secures verification of payments paid on an applicant's current or past rental.",
        "key": "203",
        "term": "Verification of rent"
      },
      {
        "definition": "Forms that request and secure information to assist the lender's credit investigation. Examples include the Verification of Employment, Verification of Mortgage, and Verification of Deposit.",
        "key": "204",
        "term": "Verifications"
      }
    ],
    "title": "V"
  },
  {
    "data": [
      {
        "definition": "The written evidence from a contractor or supplier, surrendering the right of lien to enforce collection of debt against a property.",
        "key": "205",
        "term": "Waiver of Lien"
      },
      {
        "definition": "A short-term lender for mortgage bankers. Using the note as collateral, the warehouse lender provides interim financing until the mortgage is sold to a permanent investor.",
        "key": "206",
        "term": "Warehouse Lender"
      },
      {
        "definition": "Borrowing of funds by a mortgage banker on a short-term basis using permanent mortgage loans as collateral. The money borrowed is used to make additional mortgage loans. This interim financing is used until the mortgages are sold to a permanent investor.",
        "key": "207",
        "term": "Warehousing"
      },
      {
        "definition": "Unsecured mortgages sold individually to investors.",
        "key": "208",
        "term": "Whole Loans"
      },
      {
        "definition": "A lender that specializes in the purchase and servicing of mortgages obtained from other mortgage origination entities, such as brokers, correspondents, thrifts, credit unions, or commercial banks.",
        "key": "209",
        "term": "Wholesale Lender"
      }
    ],
    "title": "W"
  }
]
